import { RiskToleranceAssessmentsService } from './rtq-assessments.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "./rtq-assessments.service";
export class RTQAssessmentsFolderableCollectionService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        return this.riskToleranceAssessmentsService.getRiskToleranceAssessmentsList(this.dataParams);
    }
    constructor(riskToleranceAssessmentsService) {
        super();
        this.riskToleranceAssessmentsService = riskToleranceAssessmentsService;
        this.scrollableBodyId = 'rtqAssessmentsItemTable';
    }
}
RTQAssessmentsFolderableCollectionService.ɵfac = function RTQAssessmentsFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RTQAssessmentsFolderableCollectionService)(i0.ɵɵinject(i1.RiskToleranceAssessmentsService)); };
RTQAssessmentsFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RTQAssessmentsFolderableCollectionService, factory: RTQAssessmentsFolderableCollectionService.ɵfac });
